export type BookingReadiness = {
  readonly status: string;
  readonly archived: boolean;
  readonly stay: { readonly checkedOutAt: string | null } | null;
  readonly reserveGaps: readonly ('guests' | 'total_not_positive' | 'company_occupant')[];
};

export type ReadinessKey = `gap_${BookingReadiness['reserveGaps'][number]}` | 'checkInGuidance';

export function readinessKeys(booking: BookingReadiness): readonly ReadinessKey[] {
  if (booking.archived) return [];
  if (booking.status === 'DRAFT') return booking.reserveGaps.map((gap): ReadinessKey => `gap_${gap}`);
  if ((booking.status === 'RESERVED' || booking.status === 'ACTIVE') && booking.stay === null) {
    return ['checkInGuidance'];
  }
  return [];
}
